import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
// eslint-disable-next-line
import {
  AgendamentoCirurgia, IRequestMessage,
  ModalAutorizacao, Solicitacao, NovaDataSolicitada, Acoes,
  Autorizacao, MedicoSolicitante, Snackbar, BodyRequest,
  AutorizacaoSolicitacaoQuery, ProtocoloOpmeMessage, TipoDocumentoUpload, AutorizarSolicitacao, ReservaHemocomponente,
  Hemocomponente, ErrorMessage, Anestesista, ReservaHemocomponenteAnestesista, SecretariaDoMedicoSolicitante } from '@/types/_'
import Apis from '@/Apis/_'

@Module({ namespaced: true, name: 'AgendamentoBackofficeAutorizacaoStore' })
export default class AgendamentoBackofficeAutorizacaoStore extends VuexModule {
  public requestMessage: IRequestMessage = {
    avancar: {
      text: 'Carregando...',
    },
    continuarDepois: {
      text: 'Enviando...',
    },
    init: {
      text: 'Carregando...',
    },
    status: true,
    deleteMessage: 'Deletando...',
    post: 'Enviando...',
    update: 'Atualizando...',
    messageFinish: 'Solicitação enviada com sucesso!',
    errorApi: 'Houve um erro no envio dos dados.',
    errorUpload: 'Houve um erro ao enviar arquivo.',
    search: 'Buscando...',
  }

  public modal: ModalAutorizacao = {
    autorizacao: false,
    autorizarProcesso: false,
    contestacaoMedica: false,
    preAnestesico: false,
    alterarCotacao: false,
    aguardandoNegociacaoParticular: false,
  }

  public medicoSolicitante: MedicoSolicitante = {
    cpf: '',
    conselhoTipo: 'CRM',
    conselhoNumero: '',
    conselhoUf: '',
    email: '',
    especialidade: '',
    hospitais: [],
    id: '',
    medicoTemUsuario: false,
    nome: '',
    recebeEmailNotificacao: false,
    telefone: '',
    urlAssinatura: '',
  }


  public secretariaDoMedicoSolicitante: SecretariaDoMedicoSolicitante = {
    nome: '',
    telefone: '',
    email: '',
  }

  private solicitacaoDefault: Solicitacao = {
    etapa: {
      display: '',
      key: '',
    },
    id: '',
    observacaoReservaSala: null,
    nomePaciente: '',
    hospitalId: '',
    dataNascimento: null,
    dataNascimentoTemp: '',
    telefone: '',
    celular: '',
    email: '',
    convenio: null,
    plano: null,
    carteirinha: '',
    diagnosticoJustificativa: '',
    resultadosDeExames: null,
    tempoCirurgia: null,
    opcaoDataPrevisto1: null,
    opcaoDataPrevisto2: null,
    opcaoDataPrevisto3: null,
    opcaoDataPrevisto1Temp: '',
    opcaoDataPrevisto2Temp: '',
    opcaoDataPrevisto3Temp: '',
    instrucaoData: null,
    dataAgendamentoVirtual: false,
    dataAgendamento: '',
    instrucaoDataPrevista: '',
    especificarPrecaucoes: '',
    alergiaLatexTemp: '',
    alergiaLatex: null,
    alergiaContraste: null,
    testeCovid: null,
    marcapasso: null,
    reoperacao: null,
    tipoAnestesia: [],
    tipoAnestesiaTemp: [],
    outrasAlergias: null,
    especificarOutrasAlergias: null,
    carater: null,
    caraterTemp: null,
    files: [],
    laudos: [],
    resumos: [],
    cids: null,
    diaria: null,
    equipamentos: null,
    caixasCirurgicas: [],
    especificacaoExameIntraOperatorio: '',
    examesIntraOperatorios: {
      anatomiaPatologica: false,
      anatomiaPatologicaHospitalOuParticular: null,
      anatomiaPatologicaParticularLocal: null,
      biobanco: false,
      biopsia: false,
      biopsiaHospitalOuParticular: null,
      biopsiaParticularLocal: null,
      broncoscopiaFlexivel: false,
      catho: false,
      cellSaver: false,
      colangiografia: false,
      colangiopancreatografiaRetrograda: false,
      colonoscopia: false,
      congelacaoIPC: false,
      congelacaoMultipat: false,
      congelacaoPathos: false,
      congelacaoFerdinando: false,
      congelacaoSalomao: false,
      congelacaoLoccus: false,
      congelacaoFleury: false,
      congelacaoEinstein: false,
      congelacaoBML: false,
      congelacaoCIPAC: false,
      congelacaoPathology: false,
      dimen: false,
      ecocardiograma: false,
      ecointraoperatório: false,
      ecotransesofagico: false,
      endoscopia: false,
      escleraUnicamp: false,
      examesLaboratoriais: false,
      fivmed: false,
      insite: false,
      mamografia: false,
      medicinaNuclear: false,
      monitorizacaoNeurofisiologica: false,
      nervoNIM: false,
      neuronavegacao: false,
      outros: false,
      outrosEspecificar: null,
      potencialEvocado: false,
      pth: false,
      radioterapia: false,
      ressonancia: false,
      rxScopia: false,
      semExameIntraoperatorio: false,
      tipagemSanguinea: false,
      tomografia: false,
      tomografiaParaEstereotaxia: false,
      transporte: false,
      udo: false,
      ultrassonografiaDeImagem: false,
      ultrassonografiaIntraoperatoria: false,
      ultrassonografiaIntraoperatoriaEquipeDoHospital: null,
      ultrassonografiaLaparoscopio: false,
      ultrassonografiaRadiologia: false,
      ultrassonografiaRadiologiaAcompanhamento: false,
    },
    honorarioMedico: null,
    honorarioMedicoTemp: null,
    honorarioMedicoDocumento: null,
    idade: null,
    lateralidade: null,
    medicoSolicitanteId: '',
    opmes: null,
    orientacaoPreparoPaciente: '',
    precaucoesTemp: null,
    precaucoes: null,
    procedimento: {
      codigo: '',
      descricao: '',
      historicoMedico: false,
      id: '',
      porte: '',
      procedimentoPrincipal: false,
      quantidade: 0,
      quantidadeAutorizada: 0,
      particular: false,
    },
    procedimentosAssociados: null,
    reservaHemocomponentes: {
      concentradoHemacias: {
        quantidade: null,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: null,
        value: false,
      },
      crioprecipitado: {
        quantidade: null,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: null,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: null,
        value: false,
      },
      semReserva: {
        quantidade: null,
        value: false,
      },
    },
    reservaUTI: {
      display: '',
      key: '',
    },
    reservaUtiTemp: null,
    anestesiaDoHospital: null,
    anestesiaDoHospitalTemp: '',
    honorarioAnestesista: null,
    honorarioAnestesistaDocumento: null,
    tipoProcedimento: null,
    tipoInternacao: null,
    lateralidadeTemp: null,
    tipoProcedimentoTemp: null,
    temMedicamentosEspeciais: null,
    temMedicacaoContinua: null,
    medicamentosEspeciais: '',
    medicacaoContinua: '',
    medEspeciaisTemp: '',
    temPrevisaoUsoQuimioterapico: null,
    usoQuimioTemp: '',
    previsaoUsoQuimioterapico: null,
    recemNascido: null,
    recemNascidoTemp: null,
    sexo: '',
    statusSituacao: '',
    codigoPrestador: '',
    medicoSolicitante: this.medicoSolicitante,
    secretariaDoMedicoSolicitante: this.secretariaDoMedicoSolicitante,
    anestesistaCrm: '',
    nomeAnestesista: '',
    anestesista: null,
    numeroAgendamento: '',
    protocoloOPME: '',
    protocoloOperadora: '',
    autorizacaoValidade: '',
    dataAutorizacaoNaOperadora: '',
    autorizadoStatus: null,
    observacao: '',
    autorizacaoObservacao: '',
    situacao: {
      display: '',
      key: '',
    },
    acoes: {
      editar: false,
      podeResolverPendencia: false,
      aceitarAutorizacaoParcial: false,
      criarContestacao: false,
      responderContestacao: false,
      solicitarCancelamento: false,
      visualizarContestacao: false,
      visualizarItensAutorizados: false,
      agendamentoConfirmaCancelamento: false,
      agendamentoFazCancelamento: false,
      agendamentoAtualizaTriagem: false,
      alterarData: false,
      analizarResposta: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
      autorizacaoFazAnalisePreCotacao: false,
      autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
      confirmarData: false,
      contatar: false,
      agendamentoRealizaTriagem: false,
      visualizar: false,
      visualizarPendencia: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
      autorizacaoFazAnalisePosCotacao: false,
      autorizacaoResolvePendenciaRoboAutorizacao: false,
      autorizacaoFazRetornoParaCotacao: false,
      autorizacaoAutorizaNegociacaoParticular: false,
      agendamentoFazReservaDeSalaParticular: false,
      agendamentoInformaReservaEmSolicitacaoParticular: false,
    },
    cotacaoOperadorasExtraGrupo: {
      faturamentoDiretoComOperadora: false,
      notaFiscal: false,
      observacao: 'Outros',
      valor: null,
      cotacaoComUrgencia: false,
      dataReferenciaParaOperadora: '',
    },
    hospitalRealizaCotacao: null,
    canceladoMotivo: {
      display: '',
      key: '',
    },
    dataVerificacaoElegibilidade: '',
    elegivel: null,
    erroVerificacaoElegibilidade: '',
    observacaoPreAnestesia: null,
    tipoAnestesiaPaciente: null,
    viasAereasDificilAcesso: null,
    preAnestesico: null,
    statusAvaliacaoPreAnestesia: {
      display: '',
      key: '',
    },
    pacienteAptoParaAnestesia: null,
    medicoAnestesistaPreAvaliacaoNome: '',
    origem: null,
    enviadaPor: null,
    pacienteUsaMarcaPasso: null,
    outrosTipoAnestesia: null,
    auditada: false,
    auditadaObservacao: '',
    salaCirurgicaNome: '',
    hospitalFazReservaDeSala: false,
    opmeFornecedores: [],
    statusAguardandoOperadora: '',
    negociacaoParticularStatus: null,
    numeroOrcamento: null,
    localAtendimentoId: null,
    localAtendimentoNome: '',
    grupoOpmeDaSolicitacao: [],

    cpf: '',
    pacienteNome: '',
    url: '',
    paciente: {
      carteirinha: '',
      celular: '',
      convenioId: '',
      convenioNome: '',
      cpf: '',
      rgh: '',
      dataNascimento: '',
      dataVerificacaoElegibilidade: '',
      elegivel: '',
      email: '',
      id: '',
      idade: '',
      nome: '',
      planoId: '',
      planoNome: '',
      categoriaId: '',
      categoriaNome: '',
      tipoAcomodacao: '',
      recemNascido: '',
      sexo: '',
      telefone: '',
      peso: '',
      altura: '',
    },
    historicoFamiliarHipertemiaMaligna: null,
    classificacaoAsa: null,
    observacaoComplementares: null,
    hospitalTemStepNaAutorizacaoParaAtualizarQuantidadeAutorizada: false,
    temInternacaoDeVespera: '',
    internacaoDeVespera: '',
    temReservaHemocomponentesSimples: null,
    pesoDoPaciente: null,
    tempoDeDoenca: null,
    farmacia: null,
    procedimentosInternacao: [],
    hospitalInsereProcedimentosDeInternacao: false,
    autorizacaoDeveInformarProtocoloDaOperadora: false,
    convenioExigeCodificacaoOpme: false,
    configuracaoOpme: {
      codificacaoDeOpmeEhObrigatorio: false,
      fazCodificacaoDeOpme: false,
      precificaValorUnitario: false,
      precificacaoValorUnitarioEhObrigatorio: false,
    },
    registraProtocoloDeRecuperacaoPrecoce: null,
  }

  public solicitacao: Solicitacao = { ...this.solicitacaoDefault }


  public reservaHemocomponente: ReservaHemocomponente = {
    concentradoHemacias: {
      quantidade: 0,
      value: false,
    },
    concentradoPlaquetas: {
      quantidade: 0,
      value: false,
    },
    crioprecipitado: {
      quantidade: 0,
      value: false,
    },
    plasmaFrescoCongelado: {
      quantidade: 0,
      value: false,
    },
    tipagemSanguinea: {
      value: false,
    },
    tipagemSanguineaABORHPAI: {
      quantidade: 0,
      value: false,
    },
    semReserva: {
      quantidade: 0,
      value: false,
    },
  }

  public cotacaoOperadorasExtraGrupoDefault = {
    faturamentoDiretoComOperadora: false,
    notaFiscal: false,
    observacao: 'Outros',
    valor: null,
    cotacaoComUrgencia: false,
    dataReferenciaParaOperadora: '',
  }

  private novaDataSolicitadaDefault: NovaDataSolicitada = {
    dataAgendamento: '',
    dataAgendamentoVirtual: false,
    solicitacaoId: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opcao: 0,
    data: '',
    hora: '',
    alterarData: false,
    numeroAgendamento: '',
  }

  public acoes: Acoes = {
    alterarData: false,
    analizarResposta: false,
    confirmarData: false,
    contatar: false,
    agendamentoRealizaTriagem: false,
    agendamentoAtualizaTriagem: false,
    visualizar: false,
    autorizacaoFazCotacao: false,
    autorizacaoAutorizar: false,
    autorizacaoAlteraSolicitacaoAutorizada: false,
    agendamentoConfirmaCancelamento: false,
    visualizarPendencia: false,
    agendamentoFazCancelamento: false,
    autorizacaoSolicitaCancelamento: false,
    autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
    anestesistaFazAvaliacao: false,
    autorizacaoAlteraCotacao: false,
    autorizacaoFazAnalisePreAutorizacao: false,
    autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
    autorizacaoFazAnalisePreCotacao: false,
  }

  private agendamentoCirurgiaDefault: AgendamentoCirurgia = {
    acoes: {
      alterarData: false,
      analizarResposta: false,
      confirmarData: false,
      contatar: false,
      agendamentoRealizaTriagem: false,
      agendamentoAtualizaTriagem: false,
      visualizar: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      abrePendenciaAdministrativa: false,
      autorizacaoAlteraSolicitacaoAutorizada: false,
      agendamentoConfirmaCancelamento: false,
      visualizarPendencia: false,
      agendamentoFazCancelamento: false,
      autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
      autorizacaoSolicitaCancelamento: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
      autorizacaoFazAnalisePreCotacao: false,
    },
    carater: '',
    convenioId: '',
    convenioNome: '',
    dataAgendamento: '',
    dataAgendamentoVirtual: false,
    dataNascimento: '',
    dataProximoContato: '',
    dataSolicitacao: '',
    etapa: {
      display: '',
      key: '',
    },
    hospitalId: '',
    hospitalNome: '',
    id: '',
    medicoId: '',
    medicoNome: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opme: '',
    pacienteNome: '',
    procedimentoPrincipalNome: '',
    situacao: {
      display: '',
      key: '',
      quantidade: 0,
    },
    situacaoData: '',
    numeroAgendamento: '',
    tempoNoStatus: '',
    lembreteStatus: '',
  }

  public agendamentoCirurgia: AgendamentoCirurgia = { ...this.agendamentoCirurgiaDefault }
  public autorizacao: Autorizacao = {
    solicitacaoId: '',
  }

  private bodyRequestDefault: BodyRequest = {
    protocoloOPME: null,
    protocoloOperadora: null,
    autorizacaoObservacao: null,
    autorizacaoValidade: null,
    statusAutorizacao: null,
    cotacaoOperadorasExtraGrupo: null,
  }

  public bodyRequest: BodyRequest = { ...this.bodyRequestDefault }

  public snackbar: Snackbar = {
    disabled: false,
    disabledBtn: false,
    message: '',
    show: false,
    timeout: 3000,
  }

  public disabled: boolean = false

  public autorizacaoQuery: AutorizacaoSolicitacaoQuery = {
    solicitacaoId: '',
    acao: null,
  }

  public protocoloOpmeMessageDefault: ProtocoloOpmeMessage = {
    protocoloOPMEMessage: '',
    protocoloOperadoraMessage: '',
  }

  public protocoloOpmeMessage: ProtocoloOpmeMessage = { ...this.protocoloOpmeMessageDefault }

  public cotacaoOperadorasExtraGrupoMessage = ''

  public cotacaoOpmeFile: any[] = []

  private autorizarSolicitacaoDefault: AutorizarSolicitacao = {
    autorizadoStatus: null,
    carteirinha: '',
    celular: '',
    dataNascimento: '',
    documentos: [],
    email: '',
    idade: null,
    observacao: '',
    operadora: '',
    pacienteNome: '',
    plano: '',
    protocoloOPME: '',
    protocoloOperadora: '',
    recemNascido: null,
    sexo: '',
    telefone: '',
  }

  public autorizarSolicitacao: AutorizarSolicitacao = { ...this.autorizarSolicitacaoDefault }

  private errorMessageDefault: ErrorMessage = {
    success: false,
    total: 0,
    errorAlergiaLatex: '',
    errorOutrasAlergias: '',
    errorviasAereasDificilAcesso: '',
    errorCarater: '',
    errorCarteirinha: '',
    errorCelular: '',
    errorCids: '',
    errorConcentradoHemaciasQnt: '',
    errorConcentradoPlaquetasQnt: '',
    errorConvenio: '',
    errorCrioprecipitadoQnt: '',
    errorDataNascimento: '',
    errorDataPrevista1: '',
    errorDataPrevista2: '',
    errorDataPrevista3: '',
    errorDiagnosticoJustificativa: '',
    errorDiarias: '',
    errorEmail: '',
    errorEquipamento: '',
    errorEspecificacaoExameIntraOperatorio: '',
    errorEspecificarAlergia: '',
    errorEspecificarPrecaucoes: '',
    errorHonorarioMedico: '',
    errorLateralidade: '',
    errorOPME: '',
    errorOpmeFornecedor1: '',
    errorOpmeQuantidade: '',
    errorPaciente: '',
    errorPlano: '',
    errorPlasmaFrescoCongeladoQnt: '',
    errorPrecaucoes: '',
    errorProcedimento: '',
    errorReservaHemocomponentes: '',
    errorReservaUti: '',
    errorTelefone: '',
    errorTempoCirurgia: '',
    errorTipoProcedimento: '',
    errorMedicamentosEspeciaisDescricao: '',
    errorPrevisaoUsoQuimioterapicoDescricao: '',
    errorAnestesistaHospital: '',
    errorMedicamentosEspeciais: '',
    errorQuimioterapico: '',
    errorRecemNascido: '',
    errorSexo: '',
    errorEquipeDoHospital: '',
    errorTipoAnestesia: '',
    errorTipoAnestesiaPaciente: '',
    errorOutrosTipoAnestesia: '',
    errorPacienteUsaMarcaPasso: '',
  }

  public errorMessage = { ...this.errorMessageDefault }

  @Action({ commit: 'setSolicitacao' })
  async getSolicitacaoById(solicitacaoId: string) {
    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.getEtapaSolicitacaoById(solicitacaoId)
    if (request.success) {
      const solicitacaoCast = request.data
      solicitacaoCast.nomePaciente = request.data.pacienteNome

      const tipoArray: any[] = []
      solicitacaoCast.tipoAnestesia.map((c) => {
        if (c.outrosTipoAnestesia) {
          solicitacaoCast.outrosTipoAnestesia = c.outrosTipoAnestesia
        }
        tipoArray.push(c.tipo.key)
        return c
      })

      solicitacaoCast.tipoAnestesiaTemp = tipoArray

      if (solicitacaoCast.hospitalRealizaCotacao && !solicitacaoCast.cotacaoOperadorasExtraGrupo) {
        solicitacaoCast.cotacaoOperadorasExtraGrupo = { ...this.cotacaoOperadorasExtraGrupoDefault }
      }

      if ([undefined, null].includes(solicitacaoCast.auditada)) {
        solicitacaoCast.auditada = false
        solicitacaoCast.auditadaObservacao = ''
      }

      this.context.commit('setAcoes', request.data.acoes)
      return solicitacaoCast
    }
    return {}
  }

  @Action({ commit: 'setSolicitacao' })
  async getSolicitacaoByEtapa(solicitacao: any) {
    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.getSolicitacaoByEtapa(solicitacao)

    if (request.success) {
      const solicitacaoCast = request.data
      solicitacaoCast.nomePaciente = request.data.pacienteNome
      if (solicitacaoCast.hospitalRealizaCotacao && !solicitacaoCast.cotacaoOperadorasExtraGrupo) {
        solicitacaoCast.cotacaoOperadorasExtraGrupo = { ...this.cotacaoOperadorasExtraGrupoDefault }
      }

      if (!solicitacaoCast.autorizacaoValidade) {
        solicitacaoCast.autorizacaoValidade = ''
      }

      if ([undefined, null].includes(solicitacaoCast.auditada)) {
        solicitacaoCast.auditada = false
        solicitacaoCast.auditadaObservacao = ''
      }

      this.context.commit('setAcoes', request.data.acoes)
      return solicitacaoCast
    }
    return {}
  }

  @Action
  async uploadLaudo(formData: any) {
    const solicitacaoId = this.solicitacao.id
    const headers: any = {
      'Content-Type': 'multipart/form-data',
    }
    const request = Apis.Agendamento.SolicitacaoCirurgiaApi.upload(formData, TipoDocumentoUpload.Laudo, headers, solicitacaoId)
    if (request.success) {
      const laudosCast = request.data
      this.context.commit('setLaudos', laudosCast)
    }
    return request
  }

  @Action
  async uploadLaudoAnestesista(formData: any) {
    const solicitacaoId = this.solicitacao.id
    const headers: any = {
      'Content-Type': 'multipart/form-data',
    }
    const request = Apis.Agendamento.SolicitacaoCirurgiaApi.upload(formData, TipoDocumentoUpload.LaudoAnestesista, headers, solicitacaoId)
    if (request.success) {
      const laudosCast = request.data
      this.context.commit('setLaudos', laudosCast)
    }
    return request
  }

  @Action
  async deleteLaudo(hospitalId: string, id: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteLaudoById(hospitalId, id)
    if (request.success) {
      this.context.commit('deleteLaudoById', id)
    }

    return request
  }


  @Action
  async autorizacaoOperadora(param: AutorizacaoSolicitacaoQuery) {
    const { solicitacaoId } = param
    const { acao } = param

    if (acao) {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.autorizaSolicitacao(solicitacaoId, acao, this.bodyRequest)
      return request.success
    }

    return false
  }

  @Action
  async anestesistaFazAvaliacao(userId: string) {
    const anestesista: Anestesista = {
      alergiaLatex: this.solicitacao.alergiaLatex,
      especificarOutrasAlergias: this.solicitacao.especificarOutrasAlergias,
      observacaoPreAnestesia: this.solicitacao.observacaoPreAnestesia,
      outrasAlergias: this.solicitacao.outrasAlergias,
      // pacienteApto: this.solicitacao.pacienteAptoParaAnestesia,
      pacienteApto: true,
      reservaHemocomponentes: [],
      reservaUTI: this.solicitacao.reservaUtiTemp,
      solicitacaoId: this.solicitacao.id,
      pacienteUsaMarcaPasso: this.solicitacao.pacienteUsaMarcaPasso,
      tipoAnestesia: [],
      userId,
      viasAereasDificilAcesso: this.solicitacao.viasAereasDificilAcesso,
    }

    this.solicitacao.tipoAnestesiaTemp.map((c) => {
      if (c === 'Outros') {
        anestesista.tipoAnestesia.push({ outrosTipoAnestesia: this.solicitacao.outrosTipoAnestesia, tipoAnestesia: c })
      } else {
        anestesista.tipoAnestesia.push({ tipoAnestesia: c })
      }
      return c
    })


    const hemocomponentes: string[] = ['concentradoHemacias', 'concentradoPlaquetas', 'crioprecipitado', 'plasmaFrescoCongelado', 'tipagemSanguineaABORHPAI', 'semReserva']
    hemocomponentes.map((m) => {
      if (this.reservaHemocomponente[m].value) {
        const reserva: ReservaHemocomponenteAnestesista = {
          // @ts-ignore
          quantidade: this.reservaHemocomponente[m].quantidade,
          // @ts-ignore
          tipo: _.upperFirst(m),
        }
        anestesista.reservaHemocomponentes.push(reserva)
      }
      return m
    })

    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.anestesistaFazAvaliacao(anestesista)
    return request.success
  }

  @Action
  async anestesistaSolicitaCancelamento() {
    const solicitacaoId: string = this.solicitacao.id

    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.anestesistaSolicitaCancelamento(solicitacaoId)
    return request.success
  }

  @Action({ commit: 'fillHemocomponentes' })
  async getReservaHemocomponente() {
    const solicitacaoId = this.solicitacao.id
    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getAllReservaHemocomponentes(solicitacaoId)

    if (request.success) {
      return request.data
    }

    return []
  }

  @Action
  async autorizaSolicitacaoOperadora(param: AutorizacaoSolicitacaoQuery) {
    const { solicitacaoId } = param
    const { acao } = param

    const bodyRequest: BodyRequest = {
      autorizacaoObservacao: this.solicitacao.autorizacaoObservacao,
      autorizacaoValidade: this.solicitacao.autorizacaoValidade,
      statusAutorizacao: this.solicitacao.situacao.key,
      cotacaoOperadorasExtraGrupo: null,
      protocoloOPME: null,
      protocoloOperadora: null,
    }

    if (acao) {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.autorizaSolicitacao(solicitacaoId, acao, bodyRequest)
      return request.success
    }

    return false
  }

  @Action
  async uploadCotacaoOperadora(formData: any) {
    const solicitacaoId = this.solicitacao.id
    const cotacaoOpme = TipoDocumentoUpload.CotacaoOpme
    const header: any = {
      'Content-Type': 'multipart/form-data',
    }
    const request = Apis.Agendamento.SolicitacaoCirurgiaApi
      .upload(formData, cotacaoOpme, header, solicitacaoId)

    return request
  }

  @Action
  async uploadAnexoOperadora(formData: any) {
    const solicitacaoId = this.solicitacao.id
    const tipoDocumento = TipoDocumentoUpload.AnexoOperadora
    const header: any = {
      'Content-Type': 'multipart/form-data',
    }
    const request = Apis.Agendamento.SolicitacaoCirurgiaApi
      .upload(formData, tipoDocumento, header, solicitacaoId)

    return request
  }

  @Action({ commit: 'setCotacaoOpmeFile' })
  async loadUploadOpmeCotacaoOperadora() {
    const solicitacaoId: string = this.solicitacao.id
    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getAllFile(solicitacaoId, TipoDocumentoUpload.CotacaoOpme)

    if (request.success) {
      return request.data
    }

    return null
  }

  @Action
  async autorizacaoAlteraCotacaoExtraGrupo() {
    const solicitacaoId: string = this.solicitacao.id
    const cotacaoOperadorasExtraGrupo = {
      cotacaoOperadorasExtraGrupo: this.solicitacao.cotacaoOperadorasExtraGrupo ? { ...this.solicitacao.cotacaoOperadorasExtraGrupo } : { ...this.cotacaoOperadorasExtraGrupoDefault },
    }

    const { observacao } = cotacaoOperadorasExtraGrupo.cotacaoOperadorasExtraGrupo || null
    if (observacao && observacao !== 'Pacote') cotacaoOperadorasExtraGrupo.cotacaoOperadorasExtraGrupo.valor = null

    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.autorizacaoAlteraCotacaoExtraGrupo(solicitacaoId, cotacaoOperadorasExtraGrupo)

    if (request.success) {
      return request.data
    }

    return false
  }

  @Mutation
  fillHemocomponentes(hemocomponentes: Hemocomponente[]) {
    hemocomponentes.map((c: Hemocomponente) => {
      switch (_.toUpper(c.tipo)) {
        case 'CONCENTRADOHEMACIAS':
          this.reservaHemocomponente.concentradoHemacias.quantidade = c.quantidade
          this.reservaHemocomponente.concentradoHemacias.value = true
          break
        case 'CONCENTRADOPLAQUETAS':
          this.reservaHemocomponente.concentradoPlaquetas.quantidade = c.quantidade
          this.reservaHemocomponente.concentradoPlaquetas.value = true
          break
        case 'CRIOPRECIPITADO':
          this.reservaHemocomponente.crioprecipitado.quantidade = c.quantidade
          this.reservaHemocomponente.crioprecipitado.value = true
          break
        case 'PLASMAFRESCOCONGELADO':
          this.reservaHemocomponente.plasmaFrescoCongelado.quantidade = c.quantidade
          this.reservaHemocomponente.plasmaFrescoCongelado.value = true
          break
        case 'TIPAGEMSANGUINEAABORHPAI':
          this.reservaHemocomponente.tipagemSanguineaABORHPAI.quantidade = c.quantidade
          this.reservaHemocomponente.tipagemSanguineaABORHPAI.value = true
          break
        case 'SEMRESERVA':
          this.reservaHemocomponente.semReserva.quantidade = c.quantidade
          this.reservaHemocomponente.semReserva.value = true
          break
        default:
          break
      }

      return c
    })
  }

  @Mutation
  setTipoAnestesia(value: any) {
    this.solicitacao.tipoAnestesiaTemp = value
  }

  @Mutation
  setOutrosTipoAnestesia(value: string) {
    this.solicitacao.outrosTipoAnestesia = value
  }

  @Mutation
  clearErrorMessage() {
    this.errorMessage = { ...this.errorMessageDefault }
  }

  @Mutation
  clearReservaHemocomponentes() {
    this.reservaHemocomponente = {
      concentradoHemacias: {
        quantidade: null,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: null,
        value: false,
      },
      crioprecipitado: {
        quantidade: null,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: null,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: null,
        value: false,
      },
      semReserva: {
        quantidade: null,
        value: false,
      },
    }
  }

  @Mutation
  async setSolicitacao(solicitacao: Solicitacao) {
    this.solicitacao = solicitacao
    // @ts-ignore
    this.solicitacao.reservaUtiTemp = solicitacao.reservaUTI.key
  }

  @Mutation
  async setErrorMessage(errorMessage: ErrorMessage) {
    this.errorMessage = errorMessage
  }

  @Mutation
  async setAutorizarSolicitacao(autorizarSolicitacao: AutorizarSolicitacao) {
    this.autorizarSolicitacao = autorizarSolicitacao
  }

  @Mutation
  async setShowModalAutorizacao(value: boolean) {
    this.modal.autorizacao = value
  }

  @Mutation
  async setShowModalContestacaoMedica(value: boolean) {
    this.modal.contestacaoMedica = value
  }

  @Mutation
  setSolicitacaoId(value: string) {
    this.solicitacao.id = value
  }

  @Mutation
  async setShowModalAutorizarProcesso(value: boolean) {
    this.modal.autorizarProcesso = value
  }

  @Mutation
  async setShowModalAguardandoNegociacaoParticular(value: boolean) {
    this.modal.aguardandoNegociacaoParticular = value
  }

  @Mutation
  async setShowModalPreAnestesico(value: boolean) {
    this.modal.preAnestesico = value
  }

  @Mutation
  setShowModalAlterarCotacao(value: boolean) {
    this.modal.alterarCotacao = value
  }

  @Mutation
  setAgendamentoCirurgia(agendamentoCirurgia: AgendamentoCirurgia) {
    this.agendamentoCirurgia = agendamentoCirurgia
  }

  @Mutation
  setProtocoloOpmeMessage(message: string) {
    this.protocoloOpmeMessage.protocoloOPMEMessage = message
  }

  @Mutation
  setProtocoloOperadoraMessage(message: string) {
    this.protocoloOpmeMessage.protocoloOperadoraMessage = message
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoMessage(message: string) {
    this.cotacaoOperadorasExtraGrupoMessage = message
  }

  @Mutation
  setAcoes(acoes: Acoes) {
    this.acoes = acoes
  }

  @Mutation
  setNomePaciente(nome: string) {
    this.solicitacao.nomePaciente = nome
  }

  @Mutation
  setNomeMedicoSolicitante(nome: string) {
    this.solicitacao.medicoSolicitante.nome = nome
  }

  @Mutation
  setLaudos(value: any) {
    if (value) {
      if (!this.solicitacao.laudos) {
        this.solicitacao.laudos = []
      }

      this.solicitacao.laudos.push(value)
    }
  }

  @Mutation
  setDisabled(value: boolean) {
    this.disabled = value
  }

  @Mutation
  deleteLaudoById(id: string) {
    const removeArray: any[] = []

    for (let i = 0; i < this.solicitacao.laudos.length; i++) {
      if (this.solicitacao.laudos[i].id === id) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.solicitacao.laudos.splice(removeArray[i], 1)
    }
  }

  @Mutation
  clearAutorizacao() {
    this.disabled = false
    this.solicitacao = { ...this.solicitacaoDefault }
    this.agendamentoCirurgia = { ...this.agendamentoCirurgiaDefault }
    this.cotacaoOpmeFile = []
    this.bodyRequest = { ...this.bodyRequestDefault }
    this.protocoloOpmeMessage = { ...this.protocoloOpmeMessageDefault }
  }

  @Mutation
  clearSolicitacao() {
    this.solicitacao = { ...this.solicitacaoDefault }
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoFaturamento(value: boolean) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) this.solicitacao.cotacaoOperadorasExtraGrupo.faturamentoDiretoComOperadora = value
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoNotaFiscal(value: boolean) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) this.solicitacao.cotacaoOperadorasExtraGrupo.notaFiscal = value
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoObservacao(value: string) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) this.solicitacao.cotacaoOperadorasExtraGrupo.observacao = value
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoValor(value: string | number | null) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) this.solicitacao.cotacaoOperadorasExtraGrupo.valor = value
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoCotacaoComUrgencia(value: boolean) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) this.solicitacao.cotacaoOperadorasExtraGrupo.cotacaoComUrgencia = value
  }
}
